import documentsReducer from "./documentsSlice";

export default documentsReducer;
